import React from 'react'

function Error(props) {
    const {error} = props;
    return (<div className="text-danger text-sm font-italic"> {error} </div>);
}

export default Error;
